import React, { useState, useEffect, useContext } from 'react';
import Loading from '../Loading';
import { Container, Row, Col } from 'react-bootstrap';
import { useLocation, useHistory } from "react-router-dom";
import MessageBox from './MessageBox';
import ReplyBox from './ReplyBox';
import { feedbackReportsGet, messageGet } from '../../api';
import { somethingWentWrongNotice } from '../UI/Notifications';
import { UserContext } from 'context/User';

const Message = ({ setTrigger, trigger }) => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const { setIsLoggedIn, setUser } = useContext(UserContext);
  const query = useQuery();
  const id = query.get("id");
  const type = query.get("type");
  const reply = query.get("reply");
  const [loading, setLoading] = useState(false);
  const [replyBoxVisibility, setReplyBoxVisibility] = useState(!!parseInt(reply));//// !!! 
  const [messageInfo, setMessageInfo] = useState({});
  const history = useHistory();
  const title = type === 'message' && 'Message' || type === 'feedback' && 'User Feedback Report'; 

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Inbox");
    }
    setLoading(false);
  }

  useEffect(() => {
    setLoading(true);
    switch (type) {
      case 'feedback':
        feedbackRequest()
        break;
      case 'message':
        messageRequest()
        break;
      default:
        setLoading(false);
    }
    setTrigger(!trigger);
  }, []);

  const feedbackRequest = () => {
    feedbackReportsGet({feedback_id: id})
      .then(response => {
        setMessageInfo(response.data);
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        setLoading(false);
      })
  }

  const messageRequest = () => {
    messageGet({message_id: id})
      .then(response => {
        setMessageInfo(response.data);
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        setLoading(false);
      })
  }

  return (
    <section className="section-spaces">
      <Container>
        <Row>
          <Col>
            <h3 className="mb-5">
              {title}
            </h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <MessageBox 
              messageInfo={messageInfo}
              replyBoxVisibility={replyBoxVisibility}
              setReplyBoxVisibility={setReplyBoxVisibility}
              type={type}
              handleDefaultStatusCodes={handleDefaultStatusCodes}
              setLoading={setLoading}
            />
            {replyBoxVisibility && (
            <ReplyBox 
              messageInfo={messageInfo}
              setReplyBoxVisibility={setReplyBoxVisibility}
              type={type}
              handleDefaultStatusCodes={handleDefaultStatusCodes}
              setLoading={setLoading}
            />
            )}
          </Col>
        </Row>
      </Container>
      {loading && <Loading />}
    </section>  
  )
}

export default Message;